










































































































































































































import { addItemsToListIfAreNotAdded, removeItemsFromList } from '../../core/utils';
import { Component, Prop, Mixins, Vue, Watch, Emit } from 'vue-property-decorator';
import { PRIVILEGE_KEYS, PRIVILEGE_TYPES } from '../../core/utils/privileges';
import { MultipleSelect, MsgBox } from '../../core/components';
import SimpleTable from '../../core/components/SimpleTable.vue';
import TableArrows from '../../core/components/TableArrows.vue';
import Checkbox from '../../core/components/Checkbox.vue';
import LabelWithValue from '../../core/components/LabelWithValue.vue'
import InfoIcon from '../../core/components/InfoIcon.vue';
import {
    AuthStoreHelper,
    RootStoreHelper,
    CompanyStoreHelper,
    StoreHelper,
    NotificationStoreHelper
} from '../../core/mixins';
import { NormsServices } from '../../norms/api/NormsServices';
import VariableClasification from '../models/VariableClasification';
import { formatDate } from '../../core/utils';
import Input from '../../core/components/Input.vue';

@Component({
    components: {
        InfoIcon,
        LabelWithValue,
        MultipleSelect, 
        MsgBox, 
        TableArrows, 
        SimpleTable,
        Input,
        Checkbox 
    }
})
export default class VariableGroup extends Mixins(
    AuthStoreHelper,
    StoreHelper,
    RootStoreHelper,
    CompanyStoreHelper,
    NotificationStoreHelper
) {
    variableClasificationList: VariableClasification[] = [];

    description: string = '';

    searchVar: string = '';
    searchVarInGroup: string = '';

    availableSelectedVariables: Array<object> = [];
    availableVariablesSelected: Array<object> = [];
    loadingAvailableVariables: boolean = false;
    selectedVariables: any[] = [];
    configureVehicles: boolean = true;
    isDefaultWarning: string = 'Al momento de activar esta opción y guardar el grupo se asigna además a todos los vehículos existentes';
    defaultValue:boolean = false;

    updateDefaultValue(value: boolean){
      this.defaultValue = value;
      this.sendDataToParent();
    }

    get headersSelectedVariables() {
        return [
            {
                text: 'Variables classification',
                value: 'description',
                sortable: true
            }
        ];
    }

    async getVariableClasificationList() {
        this.loadingAvailableVariables = true;
        this.variableClasificationList = await NormsServices.getVariableClassificationList();
        this.loadingAvailableVariables = false;
        if (this.editing) {
            this.removeSelectedVariableFromMainList(this.selectedVariables);
            return this.variableClasificationList;
        } else {
            return this.variableClasificationList;
        }
    }

    updateConfigureVehicles(value){
        this.configureVehicles = value;
    }

    moveVariableToTheRight() {
        this.selectedVariables = addItemsToListIfAreNotAdded(
            this.selectedVariables,
            this.availableVariablesSelected,
            'id'
        );

        this.removeSelectedVariableFromMainList(this.selectedVariables);
        this.availableVariablesSelected = [];
    }

    moveVariableToTheLeft() {
        this.removeSelectedVariable();
    }

    updateavailableVariablesSelected(rows) {
        this.availableVariablesSelected = rows;
    }

    removeSelectedVariableFromMainList(itemsToExclude) {
        this.variableClasificationList = removeItemsFromList(this.variableClasificationList, itemsToExclude, 'id');
        this.availableSelectedVariables = [];
    }

    removeSelectedVariable() {
        this.variableClasificationList = addItemsToListIfAreNotAdded(
            this.variableClasificationList,
            this.availableSelectedVariables,
            'id'
        );
        this.selectedVariables = removeItemsFromList(this.selectedVariables, this.availableSelectedVariables, 'id');
        this.availableSelectedVariables = [];
    }

    updateSelectedVariables(rows) {
        this.availableSelectedVariables = rows;
    }
    updateSearchVar(value) {
        this.searchVar = value;
    }
    updateSearchInVarGroup(value) {
        this.searchVarInGroup = value;
    }

    get headersAvailableVariables() {
        return [
            {
                text: 'Variables classification',
                value: 'description',
                sortable: true
            }
        ];
    }

    @Prop() editing: boolean;
    @Prop() visible: boolean;
    @Prop() variableGroupToEdit: any;
    modalWidth: string = '1300';
    errorMsg: string = '';

    nameRules: any = [v => !!v || 'Debe ingresar el nombre', v => (v && v.length >= 1) || 'Debe ingresar el nombre'];

    processingRequest: boolean = false;
    valid: boolean = false;

    mounted() {
        this.getVariableClasificationList();
        this.loadModalData();
    }

    updateDescription(value){
        this.description = value;
        this.sendDataToParent();
    }

    // @Watch('visible')
    loadModalData() {
      this.defaultValue = false;
      this.description = '';
      this.selectedVariables = [];

      if (this.editing && this.variableGroupToEdit !== null) {
          this.defaultValue = this.variableGroupToEdit.is_default;
          this.description = this.variableGroupToEdit.description;
          this.selectedVariables = [...this.variableGroupToEdit.variable_clasifications];
      }
    }

    format(date: string) {
        return formatDate(date);
    }

    submitVariableGroup() {
        this.sendDataToParent();
        if (!this.editing) {
            this.$emit('submitVariableGroup');
        } else {
            this.$emit('submitEditedVariableGroup');
        }
    }

    @Watch('editing')
    disableCompanyListenerOnVariableGroup() {
        this.$_disableListenkey();
    }

    get canSaveVariableGroup() {
        this.errorMsg = '';
        if (this.description.length == 0) {
            this.errorMsg = 'No ingresó el nombre del grupo';
            return false;
        }

        if (this.selectedVariables.length == 0) {
            this.errorMsg = 'No seleccionó ninguna variable';
            return false;
        }

        if (this.selectedVariables.length > 30) {
            this.errorMsg = 'El equipo no soporta más de 30 variables';
            return false;
        }
        return true;
    }

    sendDataToParent() {
        this.disableCompanyListenerOnVariableGroup();
        let submitedData = {
            description: this.description,
            variable_classifications: this.selectedVariables.map(variable => {
                return variable.id;
            }),
            configure_vehicles: this.configureVehicles,
            is_default: this.defaultValue
        };
        this.$emit('submit', submitedData);
    }

    removeDuplicatedFromObject(object) {
        let uniqueObject = object.filter(function(item, pos) {
            return object.indexOf(item) == pos;
        });

        return uniqueObject;
    }

    @Emit()
    closeDialog(action: boolean, variableGroup: any) {}
}
